import { FF_ENABLE_ORDER_PRODUCT_TAX_DISCLAIMER } from '@/constants/featureFlags';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { Typography } from '@montugroup/design-system';
import type { SxProps, Theme } from '@mui/material/styles';
import { ORDER_PRODUCT_TAX_DISCLAIMER } from './constants';

type OrderProductTaxDisclaimerProps = {
  sx?: SxProps<Theme>;
};

/** GST disclaimer shown near order totals. Renders nothing while enable_order_product_tax_disclaimer is off. */
export function OrderProductTaxDisclaimer({ sx }: OrderProductTaxDisclaimerProps) {
  const shouldShowTaxDisclaimer = Boolean(useFeatureFlag(FF_ENABLE_ORDER_PRODUCT_TAX_DISCLAIMER));

  if (!shouldShowTaxDisclaimer) {
    return null;
  }

  return (
    <Typography variant="caption" component="p" sx={sx}>
      {ORDER_PRODUCT_TAX_DISCLAIMER}
    </Typography>
  );
}
